module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "left-wrapper"
  }, [_c('div', {
    staticClass: "app-detail"
  }, [_c('router-link', {
    staticClass: "app-link",
    attrs: {
      "to": "/s-mart/personal_center/works/"
    }
  }, [_c('i', {
    staticClass: "icon-upper"
  })]), _vm._v(" "), _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.appLogo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userName))])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "account-list list-box"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "detail",
      "exact": ""
    }
  }, [_vm._v("作品概况")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "basic_information"
    }
  }, [_vm._v("基础资料")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "works_pictures"
    }
  }, [_vm._v("作品图片")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "version_file"
    }
  }, [_vm._v("版本文件")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "work_information"
    }
  }, [_vm._v("作品资料")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "trading_mode"
    }
  }, [_vm._v("交易模式")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "collect_user"
    }
  }, [_vm._v("收藏用户")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "download_user"
    }
  }, [_vm._v("下载用户")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('router-view', {
    attrs: {
      "appLogo": _vm.appLogo
    },
    on: {
      "update:appLogo": function($event) {
        _vm.appLogo = $event
      },
      "update:app-logo": function($event) {
        _vm.appLogo = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c6b555b6!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works_detail.vue
// module id = eWzL
// module chunks = 16